module.exports = __webpack_public_path__ + "img/icons-16-line-add.63054731.svg";